import { FC } from 'react';
import { Space, Skeleton } from 'antd';

const SkeletonLoading: FC = () => {
  return (
    <div>
      <Space>
        <Skeleton.Input active size={'small'} />
        <Skeleton.Input active size={'small'} />
        <Skeleton.Input active size={'small'} />
      </Space>

      <br />
      <br />
      <Skeleton active />

      <br />
      <Skeleton active />

      <br />
      <Skeleton active />

      <br />
      <Skeleton active />
    </div>
  );
};

export default SkeletonLoading;
